import { useTranslation } from "react-i18next";
import { useState } from "react";
import devices from '../../asset/export/iphone3.png';
import devicesbig from '../../asset/export/iphone5.png';
import logo1 from '../../asset/export/ApplePayTDB1.png';
import useScreenSize from "../../useScreenSize";
import { LazyLoadImage } from 'react-lazy-load-image-component';
// eslint-disable-next-line import/no-anonymous-default-export
export default (
) => {
    const { t, i18n: { changeLanguage, language } } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(language);
    const screenSize = useScreenSize();
    const handleChangeLanguage = () => {
        const newLanguage = currentLanguage === "en" ? "mn" : "en";
        setCurrentLanguage(newLanguage);
        changeLanguage(newLanguage);
    }
    return (
        <div className="relative flex  flex-col  justify-evenly items-center   snap-start bg-[url('/src/asset/bg6.jfif')] bg-cover  min-h-96 overflow-hidden h-screen ">
            <div className="rounded-full right-8 md:right-20 lg:right-32 absolute top-4 z-10 grid grid-flow-col gap-2 ">
                <button
                    type="button"
                    onClick={handleChangeLanguage}
                >
                    {
                        language === 'en' ?
                            <span className="font-semibold rounded-lg border-2  border-black px-3  bg-white text-sm text-black  text- "> MN</span> :
                            <span className="font-semibold rounded-lg border-2  border-black px-3  text-sm text-white bg-black ">   MN</span>
                    }
                </button>
                <button
                    type="button"
                    onClick={handleChangeLanguage}
                >
                    {
                        language === 'en' ?
                            <span className="font-semibold rounded-lg border-2  border-black px-3 text-sm text-white bg-black "> EN</span>
                            :
                            <span className="font-semibold rounded-lg border-2  border-black px-3  text-sm text-black bg-white "> EN</span>
                    }
                </button>
            </div>

            <img alt='' src={logo1} className='w-1/2 md:w-1/3 bg-transparent   object-contain ' />

            <h1 className="text-xl md:text-4xl py-8 xl:text-[70px]  font-bold leading-9 -mt-8">
                {t("Header1")}  {t("Header2")}
            </h1>



            <div className=" flex flex-col justify-start items-center w-1/2  md:w-1/3 h-[50vh] ">
                <LazyLoadImage effect="blur" src={devicesbig} alt="" className='bg-transparent   ' />

            </div>

        </div>


    );
};
